<app-page-shell>
  <app-page-detail-hero
    [eyebrow]="referenceType === 'BOOKING' ? 'Booking Commercial Workspace' : 'Bill of Lading Commercial Workspace'"
    [title]="title"
    [subtitle]="subtitle"
    icon="pi pi-briefcase">
    <div tags>
      <p-tag *ngIf="workspace?.bookingNumber" [value]="'Booking: ' + workspace?.bookingNumber" severity="info"></p-tag>
      <p-tag *ngIf="workspace?.billOfLadingNumber" [value]="'BL: ' + workspace?.billOfLadingNumber" severity="secondary"></p-tag>
    </div>
    <div actions>
      <app-execution-sales-order-button *ngIf="workspace?.logisticsProjectId"
        sourceType="LOGISTICS_PROJECT"
        [sourceId]="workspace?.logisticsProjectId"
        [owningCompanyId]="workspace?.owningCompanyId"
        [sourceLabel]="workspace?.logisticsProjectNumber || workspace?.referenceNumber">
      </app-execution-sales-order-button>
      <p-button *ngIf="workspace?.logisticsProjectId" label="Open Project" icon="pi pi-sitemap"
        severity="secondary" [outlined]="true" (onClick)="openProject()"></p-button>
      <p-button label="Back to Cases" icon="pi pi-arrow-left" severity="secondary" [outlined]="true"
        (onClick)="backToCases()"></p-button>
    </div>
  </app-page-detail-hero>

  <app-page-metric-strip [metrics]="metrics"></app-page-metric-strip>

  <app-page-data-panel title="Booking Commercial Context"
    subtitle="One logistics project owns commercial documents for all cases under this booking or bill of lading."
    [resultText]="workspace?.logisticsProjectNumber || 'Project pending'">
    <div *ngIf="isLoading" class="workspace-loading"><p-progressBar mode="indeterminate" [style]="{ height: '4px' }"></p-progressBar></div>
    <div *ngIf="loadError" class="workspace-error">{{ loadError }}</div>
    <div *ngIf="!isLoading && workspace" class="commercial-facts">
      <div>
        <span>Shared Project</span>
        <strong>{{ workspace.logisticsProjectNumber || 'Not linked' }}</strong>
        <small>{{ workspace.logisticsProjectName || 'No commercial project has been created for this reference.' }}</small>
      </div>
      <div>
        <span>Booking Number</span>
        <strong>{{ workspace.bookingNumber || 'Not captured' }}</strong>
        <small>Shared across the listed container cases.</small>
      </div>
      <div>
        <span>Bill of Lading</span>
        <strong>{{ workspace.billOfLadingNumber || 'Not captured' }}</strong>
        <small>Commercial reference for the booking aggregate.</small>
      </div>
    </div>
  </app-page-data-panel>

  <app-page-data-panel title="Container Cases" [subtitle]="'Lifecycle cases under ' + (referenceType === 'BOOKING' ? 'this booking.' : 'this bill of lading.')"
    [resultText]="(workspace?.containerCases?.length || 0) + ' cases'">
    <p-table [value]="workspace?.containerCases || []" [loading]="isLoading" dataKey="id" styleClass="p-datatable-sm booking-case-table">
      <ng-template pTemplate="header">
        <tr>
          <th>Case</th>
          <th>Container</th>
          <th>Lifecycle & Journey</th>
          <th>Active Control</th>
          <th class="actions-column">Actions</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-containerCase>
        <tr>
          <td><button type="button" class="case-link" (click)="openCase(containerCase)">{{ containerCase.caseNumber || 'Case pending' }}</button></td>
          <td>
            <div class="container-stack">
              <strong>{{ containerCase.containerNumber || 'Container number pending' }}</strong>
              <span>{{ containerCase.isoEquipmentType || 'Equipment pending' }}</span>
            </div>
          </td>
          <td>
            <div class="lifecycle-stack">
              <p-tag [value]="containerCase.status || 'OPEN'" [severity]="statusSeverity(containerCase.status)"></p-tag>
              <span>{{ containerCase.currentState || 'State pending' }}</span>
              <div *ngIf="hasJourneyProgress(containerCase); else journeyPlanPending" class="booking-journey-progress"
                [class.on-hold]="containerCase.status === 'ON_HOLD'"
                [class.completed]="journeyProgressPercent(containerCase) === 100">
                <div class="booking-journey-progress-heading">
                  <span>Journey completion</span>
                  <strong>{{ journeyProgressPercent(containerCase) }}%</strong>
                </div>
                <p-progressBar [value]="journeyProgressPercent(containerCase)" [showValue]="false"></p-progressBar>
                <small>{{ journeyProgressCaption(containerCase) }}</small>
                <small class="journey-current-step">Current: {{ journeyCurrentStepLabel(containerCase) }}</small>
              </div>
              <ng-template #journeyPlanPending>
                <small class="journey-plan-pending">Journey plan pending</small>
              </ng-template>
            </div>
          </td>
          <td>{{ controlLabel(containerCase) }}</td>
          <td class="actions-column"><p-button icon="pi pi-eye" [rounded]="true" [text]="true" severity="info"
            pTooltip="Open container case" (onClick)="openCase(containerCase)"></p-button></td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage"><tr><td colspan="5"><div class="empty-state">No container cases are linked to this reference.</div></td></tr></ng-template>
    </p-table>
  </app-page-data-panel>
</app-page-shell>
